// returns beginning of the current day timestamp
export const getCurrentDayTS = (): number => new Date().setHours(0, 0, 0, 0);

export const getDaysOfUsage = (installDate: number): number => {
  const dayInMs = 24 * 60 * 60 * 1000;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const install = new Date(installDate);
  install.setHours(0, 0, 0, 0);

  const diff = Math.abs(today.getTime() - install.getTime());
  return Math.floor(diff / dayInMs);
};

const roundValue = (num: number): number => Math.floor(Number(num) / 5);

export const isWithinOffset = (
  ref: number,
  counter: number,
  offset: number
): boolean => {
  const count = roundValue(counter);
  return count >= ref && ref <= count + offset;
};
